import {Box, BoxProps} from '@mui/material';
import {TokenInfo} from '@uniswap/token-lists';

export interface TokenLogoProps extends BoxProps {
  token: TokenInfo;
}

export const TokenLogo = ({
  token,
  width = '1.3rem',
  height = '1.3rem',
  ...props
}: TokenLogoProps) => {
  if (!token.logoURI) {
    return null;
  }
  return (
    <Box
      {...props}
      width={width}
      minWidth={width}
      component="img"
      height={height}
      src={token?.logoURI}
      alt={token?.symbol}
    />
  );
};
